import {match} from 'ts-pattern';

import {always} from 'ramda';

import {
  MAZDA_CLAIM_MAINTENANCE_DONE_RIGHT,
  MAZDA_CLAIM_MAINTENANCE_NOT_DONE_CORRECTLY,
} from '../types/MazdaClaimSendFormType';

export const toMazdaClaimMaintenanceAnswer = (value: boolean | null | undefined) =>
  match(value)
    .with(true, always(MAZDA_CLAIM_MAINTENANCE_DONE_RIGHT))
    .with(false, always(MAZDA_CLAIM_MAINTENANCE_NOT_DONE_CORRECTLY))
    .otherwise(always(undefined));
